import api from 'services/api';

const normalizeProdutos = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    if (Array.isArray(payload.produtos_filtrados)) {
      return payload.produtos_filtrados;
    }

    if (Array.isArray(payload.produtos_almoxarifados_filtrados)) {
      return payload.produtos_almoxarifados_filtrados;
    }

    if (Array.isArray(payload.produtos_almoxarifados_filtrados?.produtos_almoxarifados_filtrados)) {
      return payload.produtos_almoxarifados_filtrados.produtos_almoxarifados_filtrados;
    }

    if (Array.isArray(payload.rows)) {
      return payload.rows;
    }
  }

  return [];
};

class MaterialBaseInfraService {
  async buscarProdutosFiltrados(signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.get('/infraestrutura/material-base/produtos-filtrados', config);

    return {
      data: {
        produtos_filtrados: normalizeProdutos(
          response.data?.data?.produtos_filtrados
          ?? response.data?.produtos_filtrados
          ?? response.data?.data
          ?? response.data,
        ),
      },
    };
  }
}

const materialBaseInfraService = new MaterialBaseInfraService();

export default materialBaseInfraService;
